import { useQuery } from '@tanstack/react-query';
import { makeGetAiPrompts } from 'main/factories/usecases/ai';

export const useGetAiPrompt = (type: string = 'User Description') => {
  return useQuery({
    queryKey: ['aiPrompt', type],
    queryFn: async () => {
      const service = makeGetAiPrompts();
      const result = await service.getAiPrompts({ type });
      return result instanceof Error ? [] : result;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled: !!localStorage.getItem('hone:session'),
  });
};
